import { ImagesVariants } from "../../../constants/VariantsOfComponents";

export const TiktokVideo = {
  image: ImagesVariants.ToolsDefaultBg,
  name: "Naizop",
  timing: 15,
};
